import { Component, OnInit } from '@angular/core';
import { AutoLogoutService } from './authentication/services/auto-logout';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(private autoLogout: AutoLogoutService) {}

  ngOnInit(): void {
    // this.autoLogout.scheduleFromRefreshToken();
  }
}